import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "transparent", "data-test-id", "type", "textAlign"];
import PropTypes from 'prop-types';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DashedLabel = _ref => {
  let {
      children,
      transparent,
      ['data-test-id']: data,
      type = 'help',
      textAlign = 'center'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    marginBlock: "200",
    alignItems: "end",
    justifyContent: "center",
    "data-test-id": data || 'dashed-label'
  }, rest, {
    children: [!transparent && /*#__PURE__*/_jsx(Flex, {
      flexGrow: 1,
      borderWidth: "100",
      borderStyle: "solid",
      borderColor: "border-core-subtle",
      "data-test-id": "dash-left",
      marginBlockEnd: "300"
    }), /*#__PURE__*/_jsx(Section, {
      paddingInlineStart: "400",
      paddingInlineEnd: "400",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(Text, {
        use: type,
        textAlign: textAlign,
        typography: "detail-200",
        children: children
      })
    }), !transparent && /*#__PURE__*/_jsx(Flex, {
      flexGrow: 1,
      borderWidth: "100",
      borderStyle: "solid",
      borderColor: "border-core-subtle",
      "data-test-id": "dash-right",
      marginBlockEnd: "300"
    })]
  }));
};
DashedLabel.displayName = 'DashedLabel';
DashedLabel.propTypes = {
  children: PropTypes.node.isRequired,
  ['data-test-id']: PropTypes.string,
  textAlign: PropTypes.oneOf(['start', 'center', 'end', 'justify']),
  transparent: PropTypes.bool,
  type: PropTypes.oneOf(['error', 'help', 'success'])
};
export default DashedLabel;